import React, { useCallback, useMemo, useRef, useState } from 'react';

import { AiChatLauncherProvider } from './AiChatLauncherContext';
import AiOpsChatIframeDrawer, { type AiChatPromptRequest } from './AiOpsChatIframeDrawer';

export function isAiChatDisabled(): boolean {
  return window.configs?.AI_CHAT_DISABLED === 'true';
}

interface Props {
  children?: React.ReactNode;
}

export default function AiChatEntry({ children }: Props) {
  const isAvailable = !isAiChatDisabled() && Boolean(window.configs?.AI_OPS_CHAT_ORIGIN);
  const [promptRequest, setPromptRequest] = useState<AiChatPromptRequest | null>(null);
  const nextRequestIdRef = useRef(1);

  const startChatWithPrompt = useCallback((prompt: string, options?: { fallbackDepartment?: string }) => {
    setPromptRequest({
      prompt,
      requestId: nextRequestIdRef.current++,
      fallbackDepartment: options?.fallbackDepartment ?? null,
    });
  }, []);

  const launcher = useMemo(() => ({ isAvailable, startChatWithPrompt }), [isAvailable, startChatWithPrompt]);

  return (
    <AiChatLauncherProvider value={launcher}>
      {children}
      {isAvailable ? <AiOpsChatIframeDrawer promptRequest={promptRequest} /> : null}
    </AiChatLauncherProvider>
  );
}
